/**
 * Mensaje de error que devolvió el backend en una respuesta de axios.
 * Las rutas responden { error } y el decorador de autenticación { message }.
 */
export function getApiError(error, fallback = 'Ocurrió un error inesperado') {
  const data = error?.response?.data;
  if (data && typeof data === 'object' && !(data instanceof Blob)) {
    return data.error || data.message || fallback;
  }
  return fallback;
}

/**
 * Igual que getApiError, pero para descargas con responseType 'blob': en ese
 * caso el JSON del error llega envuelto en un Blob y hay que leerlo primero.
 */
export async function getBlobApiError(error, fallback = 'Ocurrió un error inesperado') {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed.error || parsed.message || fallback;
    } catch {
      return fallback;
    }
  }
  return getApiError(error, fallback);
}
